import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
import { WatchNowOfferFragmentDoc } from './WatchNowOffer.fragment';
export type UpcomingTitleGraphql_Movie_Fragment = {
	__typename: 'Movie';
	id: string;
	objectId: number;
	objectType: Types.ObjectType;
	freeOffersCount: number;
	dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
	likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
	watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
	seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
	customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
	content: {
		__typename?: 'MovieContent';
		title: string;
		fullPath: string;
		posterUrl?: string | null;
		isReleased: boolean;
		scoring: { __typename?: 'Scoring'; imdbScore?: number | null };
	};
	watchNowOffer?: {
		__typename: 'Offer';
		id: string;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		lastChangeRetailPriceValue?: number | null;
		currency?: string | null;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		availableTo?: any | null;
		dateCreated?: any | null;
		newElementCount?: number | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			icon: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			iconWide: string;
			hasRectangularIcon: boolean;
		};
	} | null;
};

export type UpcomingTitleGraphql_Season_Fragment = {
	__typename: 'Season';
	id: string;
	objectId: number;
	objectType: Types.ObjectType;
	seenState: { __typename?: 'ShowSeenState'; seenEpisodeCount: number; progress: number };
	content: {
		__typename?: 'SeasonContent';
		seasonNumber: number;
		title: string;
		fullPath: string;
		posterUrl?: string | null;
		isReleased: boolean;
		scoring: { __typename?: 'Scoring'; imdbScore?: number | null };
	};
	likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
	dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
	show: {
		__typename: 'Show';
		id: string;
		objectId: number;
		objectType: Types.ObjectType;
		content: {
			__typename?: 'ShowContent';
			title: string;
			shortDescription?: string | null;
			fullPath: string;
			posterUrl?: string | null;
			runtime?: number | null;
			scoring: {
				__typename?: 'Scoring';
				imdbVotes?: number | null;
				imdbScore?: number | null;
				tmdbPopularity?: number | null;
				tmdbScore?: number | null;
			};
			genres: Array<{ __typename?: 'Genre'; translation: string }>;
		};
		watchNowOffer?: {
			__typename: 'Offer';
			id: string;
			standardWebURL?: string | null;
			preAffiliatedStandardWebURL?: string | null;
			streamUrl?: string | null;
			streamUrlExternalPlayer?: string | null;
			retailPrice?: string | null;
			retailPriceValue?: number | null;
			lastChangeRetailPriceValue?: number | null;
			currency?: string | null;
			presentationType: Types.PresentationType;
			monetizationType: Types.MonetizationType;
			availableTo?: any | null;
			dateCreated?: any | null;
			newElementCount?: number | null;
			mediaDealId?: number | null;
			package: {
				__typename?: 'Package';
				id: string;
				icon: string;
				packageId: number;
				clearName: string;
				shortName: string;
				technicalName: string;
				iconWide: string;
				hasRectangularIcon: boolean;
			};
		} | null;
		tvShowTrackingEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
		likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
		dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
		watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
		customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
		seenState: { __typename?: 'ShowSeenState'; progress: number };
	};
	watchNowOffer?: {
		__typename: 'Offer';
		id: string;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		lastChangeRetailPriceValue?: number | null;
		currency?: string | null;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		availableTo?: any | null;
		dateCreated?: any | null;
		newElementCount?: number | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			icon: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			iconWide: string;
			hasRectangularIcon: boolean;
		};
	} | null;
};

export type UpcomingTitleGraphqlFragment = UpcomingTitleGraphql_Movie_Fragment | UpcomingTitleGraphql_Season_Fragment;

export const UpcomingTitleGraphqlFragmentDoc = gql`
	fragment UpcomingTitleGraphql on MovieOrSeason {
		__typename
		id
		objectId
		objectType
		content(country: $country, language: $language) {
			title
			fullPath
			scoring {
				imdbScore
			}
			posterUrl(profile: $profile, format: $format)
			isReleased
		}
		watchNowOffer(country: $country, platform: $platform, filter: $filter) {
			...WatchNowOffer
		}
		... on Movie {
			dislikelistEntry {
				createdAt
			}
			likelistEntry {
				createdAt
			}
			watchlistEntryV2 {
				createdAt
			}
			seenlistEntry {
				createdAt
			}
			customlistEntries {
				createdAt
			}
			freeOffersCount: offerCount(country: $country, platform: $platform, filter: { monetizationTypes: [FREE] })
		}
		... on Season {
			seenState(country: $country) {
				seenEpisodeCount
				progress
			}
			content(country: $country, language: $language) {
				seasonNumber
			}
			likelistEntry {
				createdAt
			}
			dislikelistEntry {
				createdAt
			}
			show {
				__typename
				id
				objectId
				objectType
				content(country: $country, language: $language) {
					title
					shortDescription
					fullPath
					scoring {
						imdbVotes
						imdbScore
						tmdbPopularity
						tmdbScore
					}
					posterUrl(profile: $profile, format: $format)
					runtime
					genres {
						translation(language: $language)
					}
				}
				watchNowOffer(country: $country, platform: $platform) {
					...WatchNowOffer
				}
				tvShowTrackingEntry {
					createdAt
				}
				likelistEntry {
					createdAt
				}
				dislikelistEntry {
					createdAt
				}
				watchlistEntryV2 {
					createdAt
				}
				customlistEntries {
					createdAt
				}
				seenState(country: $country) {
					progress
				}
			}
		}
	}
	${WatchNowOfferFragmentDoc}
`;
